const common = {
  "nav.home": "Accueil",
  "nav.live": "TV en direct",
  "nav.news": "Actualités",
  "nav.programs": "Émissions",
  "nav.videos": "Vidéos",
  "nav.schedule": "Grille TV",
  "nav.entertainment": "Divertissement & Culture",
  "nav.sports": "Sports",
  "nav.photoStudio": "Studio Photo",
  "nav.production": "Production",
  "nav.gallery": "Galerie",
  "nav.about": "À propos de L+TV",
  "nav.contact": "Contact",
  "nav.adverts": "Annonces",
  "nav.more": "Plus",
  "nav.watchLive": "EN DIRECT",
  "nav.edea": "Edea, Cameroun",

  "footer.quickLinks": "Liens rapides",
  "footer.departments": "Départements",
  "footer.socialMedia": "Réseaux sociaux",
  "footer.legal": "Mentions légales",
  "footer.privacy": "Politique de confidentialité",
  "footer.terms": "Conditions d'utilisation",
  "footer.cookies": "Politique de cookies",
  "footer.disclaimer": "Avertissement",
  "footer.home": "Accueil",
  "footer.live": "TV en direct",
  "footer.news": "Actualités",
  "footer.programs": "Émissions",
  "footer.videos": "Vidéos",
  "footer.gallery": "Galerie",
  "footer.schedule": "Grille",
  "footer.about": "À propos",
  "footer.contact": "Contact",
  "footer.entertainment": "Divertissement & Culture",
  "footer.technical": "Technique & Diffusion",
  "footer.photoStudio": "Studio Photo",
  "footer.production": "Production",
  "footer.allRightsReserved": "Tous droits réservés.",

  "lang.english": "English",
  "lang.french": "Français",
};

export default common;